import { DealerDashboardFilters } from "@Pages/DealersDashboard/DealersDashboard";
import { useQuery } from "@tanstack/react-query";
import { getLenderDecisionsByStatus } from "../http/lenderDecisions";

export const useGetLenderDecisionsByStatus = (
  query: DealerDashboardFilters
) => {
  return useQuery(["lenderDecisionsByStatus", query], () =>
    getLenderDecisionsByStatus({
      ...query,
      ...(query?.filterType === "all"
        ? {
            year: undefined,
            month: undefined,
          }
        : query?.filterType === "yearly"
        ? {
            month: undefined,
          }
        : {}),
    })
  );
};
